import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class Communication extends Component {

    render() {
        const title = t('menu.support.p7');
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'communication'}
            title={ title }
            exportTitle={`<h2>${title}</h2>`}
            exportFileName={'communication.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Communication);